import React from 'react';
import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoCall } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";


const Footer = () => {
    return (
        <div>
            {/* ----------------------------Footer Section------------------------------------ */}
            <footer className="footer text-dark">
                <div className="container" style={{ padding: '3rem 2rem 1rem 2rem' }}>
                    <div className='row'>
                        <div className='col-md-4 mb-4 d-flex'>
                            <div className='d-flex align-items-center flex-column'>
                                <Link to="/">
                                    <img
                                        src="/assets/imgs/logo.png"
                                        alt="JJ Associates Logo"
                                        className="footer-logo"
                                    />
                                </Link>
                                <p className="footer-tagline">JJ Associates – Trusted since 2000</p>
                            </div>
                        </div>
                        <div className='col-md-4 mb-4' style={{ overflowWrap: "anywhere" }}>
                            <p className='footer-title'>Contact</p>
                            <div className='d-flex gap-2 align-items-center pb-2'>
                                <div><IoCall className='footer-i' /></div>
                                <div><Link className='mb-0 footer-menu' to='tel:+912812480490'>(0281) 2480490 / 890</Link></div>
                            </div>
                            <div className='d-flex gap-2 align-items-center pb-2'>
                                <div><IoMdMail className='footer-i' /></div>
                                <div><Link className='mb-0 footer-menu' to='mailto:tanishqjjassociates@gmail.com'>tanishqjjassociates@gmail.com</Link></div>
                            </div>
                        </div>
                        <div className='col-md-4 mb-4'>
                            <p className='footer-title'>Location</p>
                            <div className='d-flex gap-2  pb-2'>
                                <div>
                                    <FaLocationDot className='footer-i' />
                                </div>
                                <div>
                                    <p className='mb-0 text-white'>J J Empire, Dr. Yagnik Road, Opp Hotel Imperial Palace, Rajkot, 360001</p>
                                </div>
                            </div>
                        </div>

                        <hr className="mt-4" />
                        <div className='d-sm-flex justify-content-between align-items-center mt-2'>
                            <div className='d-flex pb-1'>
                                <ul className='list-unstyled d-md-flex gap-4 mb-0'>
                                    <li><Link to="/" className='footer-menu'>Home</Link></li>
                                    <li><Link to="/about" className='footer-menu'>About Us</Link></li>
                                    <li><Link to="/privacy-policy" className='footer-menu'>Privacy Policy</Link></li>
                                </ul>
                            </div>
                            <div className='d-flex align-items-center gap-3'>
                                <div>
                                    <Link to="https://www.instagram.com/tanishq_yagnikroad_rajkot?igsh=MTF5dXl0ZDk5anFyMg==" target="_blank"
                                        rel="noopener noreferrer" aria-label="Instagram">
                                        <FaInstagram className='footer-i2' />
                                    </Link>
                                </div>
                            </div>
                        </div>


                        {/* Footer Bottom */}
                        <hr className="mt-2 mb-2" />
                        <div className='row'>
                            <div className='col-md-6'>
                                <div>
                                    <p style={{ color: "gray", fontSize: "14px" }}>Created by <Link to='https://octowebinfotech.com/' target="_blank"
                                        rel="noopener noreferrer" className='footer-link' style={{ fontSize: "14px" }}> Octoweb Infotech</Link></p>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className="d-md-flex justify-content-end align-items-center">
                                    <p style={{ color: "gray", fontSize: "14px" }}>
                                        Copyright © JJ Associates 2025. All rights reserved.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer